import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Epic%20anime%20style%20battle%20scene%20with%20multiple%20ninja%20silhouettes%20on%20a%20mountain%20top%20at%20sunset%2C%20dramatic%20orange%20and%20red%20sky%2C%20silhouetted%20ninjas%20in%20dynamic%20poses%2C%20epic%20cinematic%20atmosphere%2C%20warm%20golden%20hour%20lighting%2C%20game%20portal%20hero%20banner%2C%20bold%20composition&width=1800&height=900&seq=hero-naruto-portal&orientation=landscape"
        alt="火影同人游戏合集 - 最热门的火影忍者同人游戏"
        title="火影同人游戏合集 - 最受欢迎的火影同人游戏合集"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full px-4 md:px-6 text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
            火影同人游戏合集
          </h1>
          <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            探索最热门的火影同人游戏，涵盖角色扮演、格斗、策略等多种玩法。
            汇聚海量忍者世界内容，以全新方式体验鸣人、佐助等经典角色的冒险故事。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/role-playing"
              className="px-8 py-3 bg-primary-500 text-white font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 text-sm whitespace-nowrap no-underline cursor-pointer"
            >
              浏览全部游戏
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 border-2 border-white/30 text-white font-semibold rounded-full hover:bg-white/10 hover:border-white/60 transition-all duration-300 text-sm whitespace-nowrap no-underline cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}